import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import VitalsTabs from '../../../components/MeasurementData/VitalsTabs/VitalsTabs';
import './MeasurementChartHeader.css';

const MeasurementChartHeader = ({
  practiceId,
  patientId,
  vitals,
  activeVital,
  patientName,
  patientDOB,
  queryType,
  setQueryType,
  dateRange,
  setDateRange,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  onQuery,
  onPrint,
  onExport,
  onEmail,
  hasData
}) => {
  return (
    <>
      <div className="mchart-header">
        <div className="mchart-tabs-wrap">
          <VitalsTabs
            practiceId={practiceId}
            patientId={patientId}
            vitals={vitals}
            active={activeVital}
            mode="chart"
          />
        </div>
        <div className="mchart-patient-info">
          <div className="mchart-info-row"><span>Name</span><span>:</span><span>{patientName}</span></div>
          <div className="mchart-info-row"><span>DOB</span><span>:</span><span>{patientDOB}</span></div>
        </div>
      </div>

      <fieldset className="mchart-fieldset">
        <legend className="mchart-legend">Query Period</legend>
        <div className="mchart-query-body">
          <div className="mchart-left">
            <div className="mchart-row">
              <label className="mchart-radio-label">
                <input
                  type="radio"
                  name="queryType"
                  value="dateRange"
                  checked={queryType === 'dateRange'}
                  onChange={(e) => setQueryType(e.target.value)}
                />
                <span>Date Range</span>
              </label>
              <select
                className="mchart-dropdown"
                value={dateRange}
                onChange={(e) => setDateRange(e.target.value)}
                disabled={queryType !== 'dateRange'}
              >
                <option>Last 30 days</option>
                <option>Last 7 days</option>
                <option>Last 14 days</option>
                <option>Last 60 days</option>
                <option>Last 90 days</option>
              </select>
            </div>

            <div className="mchart-row">
              <label className="mchart-radio-label">
                <input
                  type="radio"
                  name="queryType"
                  value="from"
                  checked={queryType === 'from'}
                  onChange={(e) => setQueryType(e.target.value)}
                />
                <span>From</span>
              </label>

              <div className="mchart-date-group">
                <div className="mchart-date-wrap">
                  <input
                    type="text"
                    className="mchart-date-input"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    placeholder="dd/mm/yyyy"
                    disabled={queryType !== 'from'}
                  />
                  <FontAwesomeIcon icon={faCalendarAlt} className="mchart-calendar-icon" />
                </div>
                <span className="mchart-to">to</span>
                <div className="mchart-date-wrap">
                  <input
                    type="text"
                    className="mchart-date-input"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    placeholder="dd/mm/yyyy"
                    disabled={queryType !== 'from'}
                  />
                  <FontAwesomeIcon icon={faCalendarAlt} className="mchart-calendar-icon" />
                </div>
              </div>
            </div>
          </div>

          <div className="mchart-actions">
            <button className="mchart-btn" onClick={onQuery}>Query</button>
            <button className="mchart-btn" onClick={onPrint}>Print</button>
            <button className="mchart-btn" onClick={onExport}>Export</button>
            <button className="mchart-btn" onClick={onEmail}>Email</button>
          </div>
        </div>
      </fieldset>
    </>
  );
};

export default MeasurementChartHeader;

